import Splide from '@splidejs/splide'
import { ARROW_PATH, CLASSES } from '../../Carousels/lib/SplideOptions'

const ImagesBlock = () => {
    document.querySelectorAll('[data-images-block]').forEach((block) => {
        const hasPagination = !!block.querySelector('[data-pagination]')
        new Splide(block, {
            type: 'carousel',
            arrowPath: ARROW_PATH,
            classes: CLASSES,
            pagination: hasPagination,
            arrows: hasPagination,
        }).mount()
    })

    return true
}

export default ImagesBlock
